import * as React from "react";
import NGAlert from "../../newcomponents/alert";

interface DetectedTagsProps {
  value: any;
  detectionMap: Record<string, string>;
  detectValue: (value: any, key: string) => boolean;
}

interface Props extends DetectedTagsProps {
  className?: string;
  style?: React.CSSProperties;
  pluralLabel: string;
}
export const DetectedTags: React.FC<Props> = ({
  pluralLabel,
  value,
  detectionMap,
  detectValue,
  className = "mb-4",
  style = {},
}) => {
  const detections: Record<string, string> = React.useMemo(() => {
    const _detections: Record<string, string> = {};
    for (const key of Object.keys(detectionMap)) {
      const detected = detectValue(value, key);
      if (detected) {
        _detections[key] = detectionMap[key];
      }
    }
    return _detections;
  }, [detectionMap, value]);

  if (Object.keys(detections).length < 1) {
    return null;
  }

  return (
    <NGAlert
      className={className}
      style={style}
      render={() => {
        return (
          <div>
            <div className="mb-2">Detected {pluralLabel}</div>
            {Object.entries(detections).map(([key, value]) => {
              return (
                <div key={key} className="mb-1">
                  <span className="font-semibold">{key}</span>: {value}
                </div>
              );
            })}
          </div>
        );
      }}
    />
  );
};

export function useHasDetectedTags({ value, detectValue, detectionMap }: DetectedTagsProps): boolean {
  const detections: Record<string, string> = React.useMemo(() => {
    const _detections: Record<string, string> = {};
    for (const key of Object.keys(detectionMap)) {
      const detected = detectValue(value, key);
      if (detected) {
        _detections[key] = detectionMap[key];
      }
    }
    return _detections;
  }, [detectionMap, value]);

  return Object.keys(detections).length > 0;
}
